'use strict';

var enhancedMatching = require('./enhancedMatching'),
    wrapNativeArrayMethod = require('./wrapNativeArrayMethod');

function buildEnhancedMatching(name) {
  return wrapNativeArrayMethod(name, enhancedMatching);
}

module.exports = buildEnhancedMatching;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/enumerable/internal/buildEnhancedMatching.js
// module id = 621
// module chunks = 0